/* eslint-disable indent */
import { html, css, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { choose } from 'lit/directives/choose.js';
import sharedStyles from '../../app/styles.js';
import { translate } from '../../helpers/translate.js';
import { dialogFooterRenderer, dialogRenderer } from '@vaadin/dialog/lit.js';
import '@vaadin/dialog/theme/material/vaadin-dialog.js';

const dialogTypes = {
    INFO: 'info',
    CONFIRM: 'confirm',
    FORM: 'form',
};

@customElement('sdb-dialog')
class SdbDialog extends LitElement {

    @property({ type: String })
    accessor type = dialogTypes.INFO;

    @property({ type: String })
    accessor heading = '';

    @property({ type: String })
    accessor confirmCaption = translate('ok');

    @property({ type: String })
    accessor cancelCaption = translate('cancel');

    @property({ type: Boolean })
    accessor confirmDisabled = false;

    @property({ type: String })
    accessor body = '';

    @property({ attribute: false })
    accessor bodyRenderer;

    @property({ type: Boolean })
    accessor opened = false;

    //Initialize width and height so you don’t pass undefined:

    @property({ type: String })
    accessor width = '';

    @property({ type: String })
    accessor height = '';

    constructor() {
        super();
        this.args = null;
    }

    static get styles() {
        return [
            sharedStyles,
            css``,
        ];
    }

    async open(args = null) {
        this.args = args;
        this.opened = true;
        await this.updateComplete;
    }

    close() {
        this.opened = false;
        this.args = null;
        this.requestUpdate();
    }

    render() {
        return html`
            <vaadin-dialog
                id="tcg_dialog"
                overlay-class="app-theme-container"
                header-title=${this.heading}
                .opened=${this.opened}
                .width=${this.width}
                .height=${this.height}
                @opened-changed=${(e) => {
                    this.opened = e.detail.value;
                }}
                ${dialogRenderer(() => this._renderDialog(), [
                    // and click behavior stay in sync across repeated opens.  // List all reactive values for correct dialog updates.
                    this.opened,
                    this.type,
                    this.body,
                    this.bodyRenderer,
                ])}
                ${dialogFooterRenderer(() => this._renderFooter(), [
                    // List all reactive values for correct footer updates.
                    this.opened,
                    this.type,
                    this.confirmDisabled,
                    this.confirmCaption,
                    this.cancelCaption,
                ])}>
            </vaadin-dialog>
        `;
    }

    _renderDialog() {
        return html`
            ${choose(this.type, [
                [dialogTypes.INFO, () => html`<p>${unsafeHTML(this.body)}</p>`],
                [dialogTypes.CONFIRM, () => html`<p ?hidden=${!this.body}>${unsafeHTML(this.body)}</p>`],
                [dialogTypes.FORM, () => this.bodyRenderer ? this.bodyRenderer() : html``],
            ], () => html`<p>unknown type</p>`)}
        `;
    }

    _renderFooter() {
        return html`
            <div class="buttons">
                <sdb-content-button
                    label=${this.cancelCaption}
                    outlined
                    ?hidden=${this.type === dialogTypes.INFO}
                    @click=${() => {
                        this._trigger('cancel');
                        this.close();
                     }}>
                </sdb-content-button>
                <sdb-content-button
                    label=${this.confirmCaption}
                    autofocus
                    secondary
                    ?disabled=${this.confirmDisabled}
                    @click=${() => {
                        this._trigger('confirm');
                        this.close();
                    }}>
                </sdb-content-button>
            </div>
        `;
    }

    _trigger(eventName) {
        this.dispatchEvent(
            new CustomEvent(eventName, {
                detail: {
                    args: this.args,
                },
                bubbles: true,
                composed: true,
            }),
        );
    }
}

